module.exports = __webpack_public_path__ + "img/withu-logo-full.cbfe2318.png";